export interface Movie {
  id: string;
  title: string;
  year: number;
  genres: string[];
  duration: number;
  region: string;
  director: string;
  language: string;
  rating: number;
  views: number;
  tags: string[];
  excerpt: string;
  synopsis: string[];
  poster: string;
  backdrop: string;
  actorIds: string[];
}

export const movies: Movie[] = [
  {
    id: 'peach-33d',
    title: '蜜桃成熟时33D',
    year: 2011,
    genres: ['爱情', '剧情', '都市'],
    duration: 98,
    region: '中国香港',
    director: '陈嘉禾',
    language: '粤语 / 国语',
    rating: 7.8,
    views: 128400,
    tags: ['本网站焦点', '成长故事', '都市爱情'],
    excerpt:
      '一颗慢慢成熟的蜜桃，记录一段关于选择、告别与重新出发的都市成长故事。',
    synopsis: [
      '故事发生在南方一座被雨水反复洗刷的海滨城市。女主角林晓莓在一间老旧影碟店工作，日复一日整理着别人遗落的故事，却始终不敢面对自己那段没有说完的青春。',
      '一次偶然的旧片修复任务，让她重新遇见多年前不告而别的男主角苏陌。两人在剪辑室昏黄的灯光下，一点点拼凑回那段被时间打乱的记忆，也逐渐看清当年误会的真相。',
      '《蜜桃成熟时33D》以细腻的镜头语言讲述成长的重量：有些果实必须经历风雨才能变甜，有些告别不是结束，而是让彼此在更成熟的时刻重新相遇。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20movie%20poster%20of%20a%20lone%20young%20woman%20standing%20in%20warm%20sunset%20light%20beside%20a%20rain-washed%20coastal%20city%2C%20soft%20peach%20and%20coral%20toned%20gradient%20background%2C%20artistic%20film%20poster%20aesthetic%2C%20minimal%20elegant%20composition%2C%20high%20detail&width=600&height=900&seq=peach33d-poster-a1&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Atmospheric%20abstract%20cinematic%20backdrop%20of%20a%20coastal%20city%20at%20dusk%20with%20soft%20peach%20coral%20and%20amber%20sky%2C%20gentle%20rain%20streaks%2C%20dreamy%20film%20grain%20texture%2C%20warm%20nostalgic%20mood%2C%20wide%20cinematic%20composition%2C%20no%20text&width=1600&height=900&seq=peach33d-backdrop-a1&orientation=landscape',
    actorIds: ['lin-xiaomei', 'su-mo', 'gu-qinghe', 'shen-yibai'],
  },
  {
    id: 'peach-1',
    title: '蜜桃成熟时',
    year: 1993,
    genres: ['爱情', '剧情'],
    duration: 92,
    region: '中国香港',
    director: '陈嘉禾',
    language: '粤语',
    rating: 7.2,
    views: 98200,
    tags: ['系列作品', '经典重映'],
    excerpt: '系列的第一颗蜜桃，讲述一段关于夏日与初恋的青涩记忆。',
    synopsis: [
      '作为系列的开篇之作，影片把镜头对准了上世纪九十年代的南方小镇，记录一段发生在盛夏的初恋故事。',
      '年少的主角在一次又一次的错过中学会表达，也在蝉鸣与海风里明白，成长本身就是一场漫长的告别。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20retro%20movie%20poster%20of%20a%20summer%20seaside%20town%20with%20warm%20peach%20and%20cream%20tones%2C%20vintage%20film%20grain%2C%20artistic%20minimal%20composition%2C%20elegant%20hand%20drawn%20aesthetic%2C%20high%20detail&width=600&height=900&seq=peach-movie-poster-b2&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Retro%20abstract%20cinematic%20backdrop%20of%20a%20sunlit%20seaside%20town%20in%20warm%20peach%20and%20cream%20tones%2C%20soft%20film%20grain%2C%20nostalgic%20summer%20mood%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=peach-movie-backdrop-b2&orientation=landscape',
    actorIds: ['jiang-wan', 'lu-xinghe'],
  },
  {
    id: 'peach-2',
    title: '蜜桃成熟时2',
    year: 1994,
    genres: ['爱情', '剧情', '都市'],
    duration: 95,
    region: '中国香港',
    director: '陈嘉禾',
    language: '粤语',
    rating: 6.9,
    views: 76400,
    tags: ['系列作品', '续作'],
    excerpt: '当蜜桃再次成熟，故事从海边小镇走进了灯光璀璨的都市。',
    synopsis: [
      '续作把故事舞台从海边小镇搬到了喧闹的都市，主角在职场与感情之间不断寻找平衡。',
      '影片用大量夜景与霓虹镜头，描绘一个人在陌生城市里重新认识自己的过程。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20urban%20movie%20poster%20of%20a%20neon%20lit%20night%20city%20with%20warm%20coral%20and%20amber%20glow%2C%20artistic%20minimal%20film%20poster%2C%20elegant%20composition%2C%20soft%20bokeh%20lights%2C%20high%20detail&width=600&height=900&seq=peach-movie-poster-c3&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20backdrop%20of%20a%20warm%20neon%20night%20city%20skyline%20in%20coral%20and%20amber%20bokeh%20lights%2C%20dreamy%20film%20grain%2C%20urban%20nostalgic%20mood%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=peach-movie-backdrop-c3&orientation=landscape',
    actorIds: ['su-mo', 'wen-qingyan'],
  },
  {
    id: 'midnight-neon',
    title: '午夜霓虹',
    year: 2021,
    genres: ['都市', '剧情', '悬疑'],
    duration: 106,
    region: '中国香港',
    director: '周予安',
    language: '粤语',
    rating: 7.5,
    views: 65100,
    tags: ['都市夜景', '悬疑氛围'],
    excerpt: '霓虹灯下，每个人都在扮演别人期待的剧本。',
    synopsis: [
      '一名在深夜出租车里度过大半人生的司机，意外拾到一盘记录着秘密的录音带。',
      '在追寻真相的过程中，他遇见了形形色色的夜归人，也逐渐直面自己尘封多年的往事。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=Stylized%20moody%20movie%20poster%20of%20a%20rainy%20neon%20city%20street%20at%20midnight%20with%20warm%20orange%20reflections%2C%20artistic%20minimal%20film%20poster%2C%20mysterious%20urban%20aesthetic%2C%20high%20detail&width=600&height=900&seq=midnight-neon-poster-d4&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20backdrop%20of%20a%20rainy%20neon%20city%20street%20at%20midnight%20with%20warm%20orange%20reflections%20on%20wet%20asphalt%2C%20mysterious%20film%20grain%20mood%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=midnight-neon-backdrop-d4&orientation=landscape',
    actorIds: ['lu-xinghe', 'qin-lang'],
  },
  {
    id: 'summer-heartbeat',
    title: '夏日心动',
    year: 2019,
    genres: ['爱情', '青春'],
    duration: 101,
    region: '中国台湾',
    director: '林书言',
    language: '国语',
    rating: 7.7,
    views: 88200,
    tags: ['青春', '治愈系'],
    excerpt: '一个夏天，一场心动，和一段再也回不去的午后。',
    synopsis: [
      '盛夏的校园里，两个性格迥异的少年因为一场校园乐队比赛而走到一起。',
      '影片用通透的光线和轻快的节奏，记录青春里那些笨拙又真诚的心动瞬间。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=Bright%20airy%20movie%20poster%20of%20a%20sunlit%20campus%20in%20summer%20with%20soft%20peach%20and%20mint%20tones%2C%20youthful%20romantic%20artistic%20film%20poster%2C%20minimal%20elegant%20composition%2C%20high%20detail&width=600&height=900&seq=summer-heartbeat-poster-e5&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20backdrop%20of%20a%20sunlit%20summer%20campus%20with%20soft%20peach%20and%20mint%20tones%2C%20warm%20bokeh%20light%20leaks%2C%20youthful%20romantic%20film%20mood%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=summer-heartbeat-backdrop-e5&orientation=landscape',
    actorIds: ['gu-qinghe', 'jiang-wan'],
  },
  {
    id: 'city-light',
    title: '城市之光',
    year: 2020,
    genres: ['都市', '剧情'],
    duration: 112,
    region: '中国大陆',
    director: '赵一鸣',
    language: '国语',
    rating: 8.1,
    views: 103500,
    tags: ['现实主义', '口碑佳作'],
    excerpt: '在巨大的城市里，总有一束光是为普通人亮着的。',
    synopsis: [
      '影片跟随三位来自不同背景的都市打工人，讲述他们在同一栋写字楼里交错的人生。',
      '在加班、通勤与疲惫之间，他们彼此照亮，也重新定义了属于自己的「城市之光」。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=Warm%20urban%20movie%20poster%20of%20a%20solitary%20figure%20walking%20in%20a%20bright%20city%20at%20dusk%20with%20amber%20and%20coral%20glow%2C%20realist%20artistic%20film%20poster%2C%20minimal%20elegant%20composition%2C%20high%20detail&width=600&height=900&seq=city-light-poster-f6&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20backdrop%20of%20a%20warm%20dusk%20city%20skyline%20with%20amber%20and%20coral%20glow%2C%20soft%20film%20grain%2C%20hopeful%20urban%20mood%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=city-light-backdrop-f6&orientation=landscape',
    actorIds: ['qin-lang', 'wen-qingyan', 'shen-yibai'],
  },
  {
    id: 'old-letter',
    title: '旧时光的信',
    year: 2018,
    genres: ['文艺', '剧情'],
    duration: 96,
    region: '中国台湾',
    director: '林书言',
    language: '国语',
    rating: 7.9,
    views: 57300,
    tags: ['文艺片', '慢节奏'],
    excerpt: '一封没有寄出的信，跨越十年终于抵达。',
    synopsis: [
      '整理祖母遗物时，女主角发现了一封写于十年前的旧信，收信人却从未收到。',
      '带着这封信，她踏上了一段寻找与和解的旅程，也重新理解了家人之间的沉默。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=Gentle%20literary%20movie%20poster%20of%20an%20old%20wooden%20desk%20with%20handwritten%20letters%20and%20dried%20flowers%20in%20warm%20sepia%20and%20peach%20tones%2C%20artistic%20minimal%20film%20poster%2C%20high%20detail&width=600&height=900&seq=old-letter-poster-g7&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20backdrop%20of%20soft%20sunlit%20dust%20particles%20over%20a%20vintage%20desk%20in%20warm%20sepia%20and%20peach%20tones%2C%20gentle%20film%20grain%2C%20literary%20nostalgic%20mood%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=old-letter-backdrop-g7&orientation=landscape',
    actorIds: ['wen-qingyan', 'gu-qinghe'],
  },
  {
    id: 'tropical-rain',
    title: '热带夜雨',
    year: 2022,
    genres: ['爱情', '剧情', '文艺'],
    duration: 108,
    region: '中国大陆',
    director: '周予安',
    language: '国语',
    rating: 7.4,
    views: 49800,
    tags: ['热带风情', '氛围感'],
    excerpt: '在终年潮湿的热带小城，一场夜雨淋湿了两颗犹豫的心。',
    synopsis: [
      '一位来小城采风的摄影师，遇见了在当地植物园工作的女孩。',
      '潮湿的空气、连绵的夜雨和疯长的绿植，见证了一段暧昧又克制的心动。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=Lush%20tropical%20romantic%20movie%20poster%20of%20a%20rainy%20night%20among%20dense%20green%20plants%20with%20warm%20amber%20lighting%20and%20peach%20accents%2C%20artistic%20minimal%20film%20poster%2C%20high%20detail&width=600&height=900&seq=tropical-rain-poster-h8&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20backdrop%20of%20a%20rainy%20tropical%20night%20among%20lush%20green%20leaves%20with%20warm%20amber%20bokeh%20light%2C%20dreamy%20film%20grain%2C%20humid%20romantic%20mood%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=tropical-rain-backdrop-h8&orientation=landscape',
    actorIds: ['jiang-wan', 'shen-yibai'],
  },
  {
    id: 'rose-apartment',
    title: '玫瑰公寓',
    year: 2020,
    genres: ['都市', '悬疑', '剧情'],
    duration: 104,
    region: '中国香港',
    director: '赵一鸣',
    language: '粤语',
    rating: 7.3,
    views: 61200,
    tags: ['悬疑', '群像'],
    excerpt: '一栋老公寓，七户人家，各自藏着不愿被翻开的故事。',
    synopsis: [
      '玫瑰公寓即将拆迁，住户们在最后的三十天里，逐渐暴露出彼此的秘密。',
      '影片以多线叙事交织出一幅都市浮世绘，也让每个人重新面对自己的选择。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=Moody%20urban%20movie%20poster%20of%20an%20old%20apartment%20building%20with%20warm%20amber%20windows%20and%20rose%20peach%20tones%2C%20mysterious%20artistic%20film%20poster%2C%20minimal%20elegant%20composition%2C%20high%20detail&width=600&height=900&seq=rose-apartment-poster-i9&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20backdrop%20of%20an%20old%20apartment%20facade%20with%20warm%20amber%20lit%20windows%20and%20rose%20peach%20tones%2C%20mysterious%20film%20grain%20mood%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=rose-apartment-backdrop-i9&orientation=landscape',
    actorIds: ['su-mo', 'qin-lang', 'lin-xiaomei'],
  },
  {
    id: 'seaside-bookstore',
    title: '海边书店',
    year: 2017,
    genres: ['文艺', '爱情'],
    duration: 99,
    region: '中国台湾',
    director: '林书言',
    language: '国语',
    rating: 8.0,
    views: 72400,
    tags: ['治愈系', '慢生活'],
    excerpt: '一家开在海边的旧书店，收留了所有迷路的灵魂。',
    synopsis: [
      '女主角辞去城市里的工作，来到海边接手一家濒临倒闭的旧书店。',
      '在来往的读者与潮起潮落之间，她慢慢找回了生活的节奏，也遇见了新的可能。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=Cozy%20seaside%20bookstore%20movie%20poster%20with%20warm%20peach%20sunset%20light%20through%20windows%20and%20stacks%20of%20books%2C%20healing%20artistic%20film%20poster%2C%20minimal%20elegant%20composition%2C%20high%20detail&width=600&height=900&seq=seaside-bookstore-poster-j10&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20backdrop%20of%20a%20cozy%20seaside%20bookstore%20with%20warm%20peach%20sunset%20light%2C%20soft%20film%20grain%2C%20healing%20calm%20mood%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=seaside-bookstore-backdrop-j10&orientation=landscape',
    actorIds: ['wen-qingyan', 'lu-xinghe'],
  },
  {
    id: 'south-train',
    title: '南方列车',
    year: 2015,
    genres: ['剧情', '公路'],
    duration: 107,
    region: '中国大陆',
    director: '赵一鸣',
    language: '国语',
    rating: 7.6,
    views: 45600,
    tags: ['公路片', '成长'],
    excerpt: '一列开往南方的绿皮火车，载着三个陌生人的秘密。',
    synopsis: [
      '三个素不相识的乘客在同一趟南下的列车上相遇，旅途中的交谈逐渐揭开各自的心事。',
      '影片用缓慢移动的车窗风景，讲述关于放下与重新出发的旅程。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=Nostalgic%20road%20movie%20poster%20of%20an%20old%20green%20train%20traveling%20through%20warm%20sunlit%20countryside%20in%20amber%20and%20peach%20tones%2C%20artistic%20minimal%20film%20poster%2C%20high%20detail&width=600&height=900&seq=south-train-poster-k11&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20backdrop%20of%20warm%20sunlit%20countryside%20passing%20by%20a%20train%20window%20in%20amber%20and%20peach%20tones%2C%20soft%20film%20grain%2C%20nostalgic%20journey%20mood%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=south-train-backdrop-k11&orientation=landscape',
    actorIds: ['lu-xinghe', 'qin-lang'],
  },
  {
    id: 'rainy-monsoon',
    title: '雨季不再来',
    year: 2016,
    genres: ['文艺', '青春'],
    duration: 94,
    region: '中国台湾',
    director: '周予安',
    language: '国语',
    rating: 7.5,
    views: 52100,
    tags: ['青春', '雨季'],
    excerpt: '有些雨季会过去，有些会一直留在心里。',
    synopsis: [
      '高中毕业那个湿漉漉的夏天，四个好友约定要一起去看海，却在出发前夜各奔东西。',
      '多年后重逢，他们才发现，那场没走完的旅行早已成了青春里最亮的坐标。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=Melancholic%20coming%20of%20age%20movie%20poster%20of%20rain%20on%20a%20school%20window%20with%20soft%20peach%20and%20grey%20tones%2C%20artistic%20minimal%20film%20poster%2C%20nostalgic%20youthful%20aesthetic%2C%20high%20detail&width=600&height=900&seq=rainy-monsoon-poster-l12&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20backdrop%20of%20rain%20droplets%20on%20a%20school%20window%20with%20soft%20peach%20and%20warm%20grey%20tones%2C%20gentle%20film%20grain%2C%20nostalgic%20youthful%20mood%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=rainy-monsoon-backdrop-l12&orientation=landscape',
    actorIds: ['gu-qinghe', 'jiang-wan'],
  },
];

export const movieGenres = ['全部', '爱情', '剧情', '都市', '文艺', '青春', '悬疑', '公路'];